let dd = require("ES/lib/dd");
let _ = require("ES/lib/lodash");
let Constants = require("../../utils/Constants");

function parseUTC(str) {
  if (!str) return null;
  // Oracle may return "2024-01-26 14:00:00" without a timezone indicator
  let s = String(str).trim();
  if (!s.includes("Z") && !s.includes("+")) {
    s = s.replace(" ", "T") + "Z";
  }
  let d = new Date(s);
  return isNaN(d.getTime()) ? null : d;
}

function formatLocalDate(utcStr) {
  let d = parseUTC(utcStr);
  if (!d) return "";
  let parts = new Intl.DateTimeFormat("en-US", {
    weekday: "long",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  }).formatToParts(d);
  let get = function (type) {
    return (_.find(parts, { type: type }) || {}).value || "";
  };
  let dayPeriod = get("dayPeriod").toLowerCase().replace(/\s/g, "");
  return (
    get("weekday") +
    " " +
    get("month") +
    " " +
    get("day") +
    " at " +
    get("hour") +
    ":" +
    get("minute") +
    " " +
    dayPeriod
  );
}

function formatDuration(startStr, stopStr) {
  let start = parseUTC(startStr);
  let stop = parseUTC(stopStr);
  if (!start || !stop) return "";
  let totalMinutes = Math.round((stop - start) / 60000);
  let hours = Math.floor(totalMinutes / 60);
  let minutes = totalMinutes % 60;
  let parts = [];
  if (hours > 0) parts.push(hours + " hour" + (hours !== 1 ? "s" : ""));
  if (minutes > 0) parts.push(minutes + " minute" + (minutes !== 1 ? "s" : ""));
  return parts.join(" ") || "0 minutes";
}

module.exports = function MaintenanceNotices({ notices }) {
  if (!notices || notices.length === 0) return null;
  return dd.div(
    {
      className: "alert alert-warning",
      style: {
        textAlign: "left",
        backgroundColor: "#F5D020",
        borderColor: "#D4A800",
        color: "#6B4500",
        marginTop: "2rem",
      },
    },
    dd.strong(null, "Upcoming Maintenance"),
    dd.ul(
      { style: { marginTop: "1rem", marginBottom: 0, paddingLeft: "1.5em" } },
      notices.map(function (n) {
        let tipid = _.get(n, "tipid");
        let tiptext = _.get(n, "message");
        let link = _.get(n, "link");
        let linktext = _.get(n, "linktext");
        let startdate = _.get(n, "startdate");
        let stopdate = _.get(n, "stopdate");
        let priority = _.get(n, "priority");
        let when = formatLocalDate(startdate);
        let duration = formatDuration(startdate, stopdate);
        let impactLabel = _.get(
          Constants.MAINTENANCE_IMPACT_LABELS,
          priority,
          "???"
        );
        return dd.li(
          {
            key: tipid,
            style: {
              listStyle: "none",
              paddingLeft: "1.0rem",
              textIndent: "-1.1rem",
              marginBottom: "1rem",
            },
          },
          dd.i({
            className: "fa fa-wrench",
            style: {
              marginLeft: "-0.5em",
              marginRight: "0.5em",
              display: "inline",
            },
          }),
          when || duration
            ? dd.span(
                null,
                "Starts ",
                dd.strong(null, when),
                duration ? ", lasting " + duration + "." : ".",
                impactLabel ? " Expected impact: " + impactLabel + "." : null
              )
            : null,
          link && linktext
            ? dd.div(
                { style: { paddingLeft: "1.4rem" } },
                dd.a({ href: link, target: "_blank" }, linktext)
              )
            : null,
          tiptext
            ? dd.div(
                { style: { marginTop: "1em", paddingLeft: "1.1rem", opacity: 0.8 } },
                tiptext
              )
            : null
        );
      })
    )
  );
};



// WEBPACK FOOTER //
// ./src/components/signin/MaintenanceNotices.js